// extracted by mini-css-extract-plugin
export var footer = "_o8-5";
export var fulfillmentInput = "_o8-0";
export var shipDateInput = "_o8-1";
export var shipmentModal = "_o8-2";
export var shipmentModalContent = "_o8-3";
export var tableContainer = "_o8-4";